import { useEffect } from "react";

import { useWindowFocus } from "@/shared/hooks/use-window-focus.hook";
import {
  AssessmentLogEventsEnum,
  AssessmentLogsHttpService,
} from "@/shared/services/assessments/assessment-logs-http.service";

export function useFocusLostTracking({
  inviteId,
  testId,
  isEnabled,
  onFocusLost,
}: {
  inviteId?: number;
  testId?: number;
  isEnabled: boolean;
  onFocusLost?: () => void;
}) {
  const isFocusLost = !useWindowFocus();

  useEffect(() => {
    const handleFocusLost = async () => {
      if (inviteId && testId) {
        await AssessmentLogsHttpService.saveInviteLogs(inviteId, testId, AssessmentLogEventsEnum.ASSESSMENT_LOST_FOCUS);
      }
      onFocusLost?.();
    };

    if (isFocusLost && isEnabled) {
      handleFocusLost();
    }
  }, [isFocusLost, isEnabled, inviteId, testId, onFocusLost]);
}
